// extracted by mini-css-extract-plugin
var _1 = "_z73cs";
export { _1 as "loading" }
